export default __webpack_public_path__ + "static/media/not-found-icon.c4e2ff53.svg";